define('home/templates/homepageFeedEmpty',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression;

  return "<div class=\"card--empty text-center\">\n<h2>"
    + alias1(container.lambda((depth0 != null ? depth0.feedMessage : depth0), depth0))
    + "</h2>\n<p class=\"text-gray spacing-top-small\">"
    + alias1(helpers.gettext.call(depth0 != null ? depth0 : {},"Until you do that, here are the latest %(number)s trending discussions on %(disqus)s.",{"name":"gettext","hash":{"disqus":"Disqus","number":(depth0 != null ? depth0.numItemsShown : depth0)},"data":data}))
    + "\n</div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {};

  return ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isLoggedIn : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "<div data-role=\"items\"></div>\n<div class=\"spacing-bottom spacing-top\">\n<a href=\"/home/explore/\" class=\"button button-fill--brand button-padding-taller button-wide text-medium\">\n"
    + container.escapeExpression(helpers.gettext.call(alias1,"Explore channels to follow",{"name":"gettext","hash":{},"data":data}))
    + "\n</a>\n</div>\n";
},"useData":true})

});
